module.exports = __webpack_public_path__ + "img/vertical_7_4_4.6328c83d.png";